export function connectRowLabel(state, reason) {
  if (state === 'working') return 'Opening…'
  if (state === 'unusable') return 'Try another account'
  if (reason === 'expired') return 'Reconnect'
  return 'Connect'
}
